import type { GroupId } from 'types/group'
import type { SearchState, ViewState } from 'types/shareable-channel'
/**
 * Gets the search state from shareable channels.
 * @param state - The Redux state
 * @returns The search state object, or null/undefined if not available
 */
export const getSearch = (state: any): SearchState | null | undefined =>
  state.search
/**
 * Gets the search state if there's a valid query (3+ characters).
 * @param state - The Redux state
 * @returns The search state if query is valid, null otherwise
 */
export const getSearchState = (state: any): SearchState | null | undefined => {
  const currentState = getSearch(state)
  if (!currentState || !currentState.query || currentState.query.length < 3)
    return null
  return currentState
}
/**
 * Gets the view state from shareable channels.
 * @param state - The Redux state
 * @returns The view state object
 */
export const getView = (state: any): ViewState => state.view
/**
 * Gets content for a specific group from the view state.
 * @param state - The Redux state
 * @param props - Object containing the group ID
 * @param props.id - The group ID to get content for
 * @returns The group content, or null if not found
 */
export const getGroupContent = (
  state: any,
  props: {
    id: GroupId | null | undefined
  },
): any => {
  return getView(state)?.byGroup[props.id ?? -1] ?? null
}
